import ViewDashboard from '@/orangehrmDashboardPlugin/pages/ViewDashboard.vue';

export default {
  'view-dashboard': ViewDashboard,
};
